/// api版本
const version = "1.0.0";
/// 发布版本号
const buildVersion = "1";
/// true 正式环境  false 测试环境  控制Log输出
const isProduct = false;
/// 应用名
const appName = "ybb";
/// 公众号appId
const appId = "wxd553cae0a752ece0";
/// 登录重定向地址
const redirectUri = "https://bbj.xinyunit.com/login";

/// aes加密解密设置
const aes_key = "broadcast_Ge06ymuyhmalq8vz1kl8uX";//32位
const aes_iv = "1200009990006688";//16位

export default {
  version,
  buildVersion,
  isProduct,
  appName,
  redirectUri,
  appId,
  aes_key,
  aes_iv
};